import { render } from "./CommercialBooking.vue?vue&type=template&id=4e000a60&scoped=true"
import script from "./CommercialBooking.vue?vue&type=script&lang=js"
export * from "./CommercialBooking.vue?vue&type=script&lang=js"

import "./CommercialBooking.vue?vue&type=style&index=0&id=4e000a60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e000a60"]])

export default __exports__